export const slugify = (text: string): string => {
  return text.toLowerCase().replaceAll(/\s+/g, '-');
};
